<template lang="pug">
#television
  .television-header
    .container
      h1.is-size-1 Watch us this Sunday
      p.collection-desc.is-size-5 10:00 AM on KCAL Channel 9<br class="is-hidden-desktop"/>(Los Angeles)
  section.section.page-section.top-section
    .columns
      #service-sidebar-column.column.is-one-quarter.is-hidden-mobile
        services-sidebar(:config="sidebarConfig")
      #service-content-column.column.is-three-quarters
        services-search
        services-filter-bar
        .episodes-wrapper
          episodes-tab(v-if="!settings.loading")
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { SEARCH } from '@/utils/http';
import EpisodesTab from '@/components/episodes/EpisodesTab.vue';
import ServicesFilterBar from '@/components/ServicesFilterBar.vue';
import ServicesSearch from '@/components/ServicesSearch.vue';
import ServicesSidebar from '@/components/episodes/ServicesSidebar.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'television-page',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const routes = [
        'episode',
        'collection',
        'speaker',
      ];
      if (from && !routes.includes(from.name)) {
        vm.$store.commit(mutationTypes.SET_EPISODES_AGGREGATIONS, {});
        vm.$store.commit(mutationTypes.SET_EPISODES, []);
        vm.$store.dispatch(actionTypes.DO_GET_CHANNELS, { filter: 'tv' })
          .then(() => {
            vm.$store.commit(mutationTypes.SET_EPISODE_COLLECTIONS, []);
            vm.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
          });
      }
    });
  },
  components: {
    EpisodesTab,
    ServicesSearch,
    ServicesFilterBar,
    ServicesSidebar,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      aggregationsDefintion: getterTypes.GET_SERVICES_AGGREGATIONS,
      channels: getterTypes.GET_CHANNELS,
      episodes: getterTypes.GET_EPISODES,
      filters: getterTypes.GET_SERVICES_FILTERS,
      refresh: getterTypes.GET_SERVICES_REFRESH,
      page: getterTypes.GET_PAGE,
    }),
    channelIds() {
      if (!this.channels) return [];
      return _.map(this.channels, 'id');
    },
    esQuery() {
      const today = moment().format('YYYY-MM-DD');
      return {
        size: 0,
        aggs: {
          by_account: {
            filter: {
              bool: {
                must: [
                  { match: { account_id: this.account.id } },
                  { terms: { channel_ids: this.channelIds } },
                  { match: { is_published: true } },
                  { range: { pub_date: { lte: today } } },
                ],
              },
            },
            aggs: this.aggregationsDefintion,
          },
        },
      };
    },
  },
  async created() {
    if (this.channels.length === 0) this.settings.loading = true;
    await this.$store.dispatch(actionTypes.DO_GET_CHANNELS, { filter: 'tv' });
    if (_.isEmpty(this.aggregations)) {
      this.settings.loading = true;
      const { data } = await SEARCH.post('/doxa_episodes/_search', this.esQuery);
      this.$store.commit(mutationTypes.SET_EPISODES_AGGREGATIONS, data.aggregations);
    }
    this.setupView();
    this.settings.loading = false;
    return Promise.resolve();
  },
  data() {
    return {
      bottom: false,
      modals: {
        filter: false,
      },
      sidebarConfig: {
        channels: false,
        speakers: false,
        years: true,
        tags: true,
      },
      settings: {
        loading: false,
        tab: 0,
      },
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    pushQueryParams() {
      if (!_.isEmpty(this.pageQuery)) {
        this.$router.push({
          name: 'television',
          query: this.pageQuery,
        });
      }
    },
    scrollHandler() {
      const y = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const adjustedHeight = pageHeight - 300;
      const bottomOfPage = visible + y >= adjustedHeight;
      this.bottom = bottomOfPage || adjustedHeight < visible;
    },
    setupView() {

    },
    unsetFilter(filter) {
      this.filters[filter] = 'all';
    },
    unsetFilters() {
      this.selectedFilters.forEach((selected) => {
        this.filters[selected.filter] = 'all';
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  watch: {
    bottom(val) {
      if (val) {
        this.$store.commit(mutationTypes.SET_SERVICES_NEXT_PAGE, true);
      }
    },
    refresh(val) {
      if (val && !this.settings.loading) {
        this.pushQueryParams();
      } else if (!val) {
        this.settings.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
#television {
  .television-header {
    @include hero;
    background-image: url("/images/ffc/tv.jpg");
  }
  #service-sidebar-column {
    padding-right: 0;
    padding-top: 0;
    min-height: 100%;
  }
  #service-content-column {
    padding-top: 0;
    padding-left: 0;
    min-height: 100%;
    .services-search, .services-filter-bar {
      background-color: $white;
      padding-bottom: 1rem;
    }
  }
  .episodes-wrapper {
    padding: 1.75rem 1.5rem;
  }
}

@media (max-width: $tablet) {
  #television {
    .television-header {
      //background-position: -900px 58px;
      background-size: cover;
      background-attachment: inherit;
    }
    #service-content-column {
      padding-left: 0;
      padding-right: 0;
      .episodes-wrapper {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
      }
    }
  }
}
</style>

<style theme="ffc" lang="scss">
#television {
  #service-content-column {
    background-color: $white-ter;
  }
}
</style>
